import WidgetSkeleton from "../widget/WidgetSkeleton";
import { formatNumber, formatPercentage } from "../../utils/formatter";

type Section2Props = {
  dataByService: any;
  dataByDestinationDomestic: any;
  dataByDestinationIntracity: any;
  isLoadingService: boolean;
  isLoadingDomestic: boolean;
  isLoadingIntracity: boolean;
};

const Section2 = ({
  dataByService,
  dataByDestinationDomestic,
  dataByDestinationIntracity,
  isLoadingService,
  isLoadingDomestic,
  isLoadingIntracity,
}: Section2Props) => {
  return (
    <div className="row mb-3 position-relative">
      <div className="mb-2 col-12 col-lg-6 position-relative overflow-hidden border-0">
        <div
          className="card bg-outbound pb-3 h-full min-h-[250px] border-0"
          id="Outbound"
        >
          {isLoadingService && <WidgetSkeleton />}

          <div className="h-full">
            <div className="card-header-brown">
              <div className="row justify-content-center align-items-center">
                <div className="col-12 col-sm-7 mb-2 mb-sm-0">
                  <div>
                    <h6 className="text-white">OUTBOUND</h6>
                    <span className="text-white">by Service</span>
                  </div>
                </div>
                <div className="text-white col-2">
                  <div>Total Volume</div>
                </div>
                <div className="text-white col-3">
                  <h4 className="text-xl font-bold">
                    {dataByService
                      ? formatNumber(dataByService.totalBeratKeseluruhan)
                      : "0"}
                  </h4>
                  <div>Kilogram</div>
                </div>
              </div>
            </div>

            <div className="card-content">
              <div className="row">
                <div className="col-12 d-flex justify-content-between">
                  {/* HIT */}
                  <div style={{ width: "20%" }}>
                    <div className="service-label">HIT</div>
                    <div className="service-section mt-3">
                      <div className="service-label mb-2">Domestic</div>
                    </div>
                    <div className="text-start">
                      <h4 className="volume-text">
                        {dataByService
                          ? formatNumber(dataByService.hit_domestic)
                          : "0"}
                      </h4>
                      <span className="text-white d-block">Kilogram</span>
                      <h4 className="volume-text text-percentage bg-text-precentage">
                        {dataByService
                          ? formatPercentage(
                              dataByService.percentage_hit_domestic
                            )
                          : "0"}
                      </h4>
                    </div>
                    <div className="service-section mt-3">
                      <div className="service-label mb-2">Intracity</div>
                    </div>
                    <div className="text-start">
                      <h4 className="volume-text">
                        {dataByService
                          ? formatNumber(dataByService.hit_intracity)
                          : "0"}
                      </h4>
                      <span className="text-white d-block">Kilogram</span>
                      <h4 className="volume-text text-percentage bg-text-precentage">
                        {dataByService
                          ? formatPercentage(
                              dataByService.percentage_hit_intracity
                            )
                          : "0"}
                      </h4>
                    </div>
                  </div>

                  {/* JET */}
                  <div style={{ width: "20%" }}>
                    <div className="service-label mb-5">JET</div>
                    <div className="text-start mb-5">
                      <h4 className="volume-text">
                        {dataByService
                          ? formatNumber(dataByService.jet_domestic)
                          : "0"}
                      </h4>
                      <span className="text-white d-block">Kilogram</span>
                      <h4 className="volume-text text-percentage bg-text-precentage">
                        {dataByService
                          ? formatPercentage(
                              dataByService.percentage_jet_domestic
                            )
                          : "0"}
                      </h4>
                    </div>
                    <div className="text-start">
                      <h4 className="volume-text">
                        {dataByService
                          ? formatNumber(dataByService.jet_intracity)
                          : "0"}
                      </h4>
                      <span className="text-white d-block">Kilogram</span>
                      <h4 className="volume-text text-percentage bg-text-precentage">
                        {dataByService
                          ? formatPercentage(
                              dataByService.percentage_jet_intracity
                            )
                          : "0"}
                      </h4>
                    </div>
                  </div>

                  {/* TREX */}
                  <div style={{ width: "20%" }}>
                    <div className="service-label mb-5">TREX</div>
                    <div className="text-start mb-5">
                      <h4 className="volume-text">
                        {dataByService
                          ? formatNumber(dataByService.trex_domestic)
                          : "0"}
                      </h4>
                      <span className="text-white d-block">Kilogram</span>
                      <h4 className="volume-text text-percentage bg-text-precentage">
                        {dataByService
                          ? formatPercentage(
                              dataByService.percentage_trex_domestic
                            )
                          : "0"}
                      </h4>
                    </div>
                    <div className="text-start">
                      <h4 className="volume-text">
                        {dataByService
                          ? formatNumber(dataByService.trex_intracity)
                          : "0"}
                      </h4>
                      <span className="text-white d-block">Kilogram</span>
                      <h4 className="volume-text text-percentage bg-text-precentage">
                        {dataByService
                          ? formatPercentage(
                              dataByService.percentage_trex_intracity
                            )
                          : "0"}
                      </h4>
                    </div>
                  </div>

                  {/* GODA */}
                  <div style={{ width: "20%" }}>
                    <div className="service-label mb-5">GODA</div>
                    <div className="text-start mb-5">
                      <h4 className="volume-text">
                        {dataByService
                          ? formatNumber(dataByService.goda_domestic)
                          : "0"}
                      </h4>
                      <span className="text-white d-block">Kilogram</span>
                      <h4 className="volume-text text-percentage bg-text-precentage">
                        {dataByService
                          ? formatPercentage(
                              dataByService.percentage_goda_domestic
                            )
                          : "0"}
                      </h4>
                    </div>
                    <div className="text-start">
                      <h4 className="volume-text">
                        {dataByService
                          ? formatNumber(dataByService.goda_intracity)
                          : "0"}
                      </h4>
                      <span className="text-white d-block">Kilogram</span>
                      <h4 className="volume-text text-percentage bg-text-precentage">
                        {dataByService
                          ? formatPercentage(
                              dataByService.percentage_goda_intracity
                            )
                          : "0"}
                      </h4>
                    </div>
                  </div>

                  {/* Rest Of */}
                  <div style={{ width: "20%" }}>
                    <div className="service-label mb-5">Rest Of</div>
                    <div className="text-start mb-5">
                      <h4 className="volume-text">
                        {dataByService
                          ? formatNumber(dataByService.other_domestic)
                          : "0"}
                      </h4>
                      <span className="text-white d-block">Kilogram</span>
                      <h4 className="volume-text text-percentage bg-text-precentage">
                        {dataByService
                          ? formatPercentage(
                              dataByService.percentage_other_domestic
                            )
                          : "0"}
                      </h4>
                    </div>
                    <div className="text-start">
                      <h4 className="volume-text">
                        {dataByService
                          ? formatNumber(dataByService.other_intracity)
                          : "0"}
                      </h4>
                      <span className="text-white d-block">Kilogram</span>
                      <h4 className="volume-text text-percentage bg-text-precentage">
                        {dataByService
                          ? formatPercentage(
                              dataByService.percentage_other_intracity
                            )
                          : "0"}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mb-2 col-lg-3 position-relative overflow-hidden border-0">
        <div
          className="card bg-outbound-type pb-3 h-full min-h-[250px] border-0"
          id="OutboundDomestic"
        >
          {isLoadingDomestic && <WidgetSkeleton />}
          <div className="h-full">
            <div className="card-header-brown">
              <div className="d-flex justify-content-between align-items-center p-1">
                <div>
                  <h6 className="text-white">OUTBOUND</h6>
                </div>
                <div className="text-white d-flex ">
                  <div>Domestic</div>
                </div>
              </div>
            </div>

            <div className="card-content">
              <div className="row">
                <div className="col-12">
                  <div
                    className="d-flex justify-content-between bg-white p-2"
                    style={{ borderRadius: "1.5rem", fontSize: "0.8rem" }}
                  >
                    <div className="text-dark" style={{ flexBasis: "50%" }}>
                      City
                    </div>
                    <div
                      className="text-dark text-start"
                      style={{ flexBasis: "30%" }}
                    >
                      Volume
                    </div>
                    <div
                      className="text-dark text-end"
                      style={{ flexBasis: "20%" }}
                    >
                      %
                    </div>
                  </div>
                </div>
              </div>
              <div className="row p-2">
                {dataByDestinationDomestic?.items?.length > 0 ? (
                  dataByDestinationDomestic.items.map(
                    (item: any, idx: number) => (
                      <div className="col-12" key={idx}>
                        <div className="d-flex justify-content-between">
                          <div
                            className="text-white fs-14 flex-grow-1"
                            style={{ flexBasis: "50%" }}
                          >
                            {idx + 1}. {item.CabangTujuan}
                          </div>
                          <div
                            className="text-white fs-14 text-start"
                            style={{ flexBasis: "30%" }}
                          >
                            {formatNumber(parseInt(item.total_berat))}
                          </div>
                          <div
                            className="text-white fs-14 text-end"
                            style={{ flexBasis: "20%" }}
                          >
                            {formatPercentage(item.persentase)}
                          </div>
                        </div>
                      </div>
                    )
                  )
                ) : (
                  <div className="text-white">No data</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mb-2 col-lg-3 position-relative overflow-hidden border-0">
        <div
          className="card bg-outbound-type pb-3 h-full min-h-[250px] border-0"
          id="OutboundIntracity"
        >
          {isLoadingIntracity && <WidgetSkeleton />}
          <div className="h-full">
            <div className="card-header-brown">
              <div className="d-flex justify-content-between align-items-center p-1">
                <div>
                  <h6 className="text-white">OUTBOUND</h6>
                </div>
                <div className="text-white d-flex ">
                  <div>Intracity</div>
                </div>
              </div>
            </div>

            <div className="card-content">
              <div className="row">
                <div className="col-12">
                  <div
                    className="d-flex justify-content-between bg-white p-2"
                    style={{ borderRadius: "1.5rem", fontSize: "0.8rem" }}
                  >
                    <div className="text-dark">City</div>
                    <div className="text-dark">Volume</div>
                    <div className="text-dark">%</div>
                  </div>
                </div>
              </div>
              <div className="row p-2">
                {dataByDestinationIntracity?.items?.length > 0 ? (
                  dataByDestinationIntracity.items.map(
                    (item: any, idx: number) => (
                      <div className="col-12" key={idx}>
                        <div className="d-flex justify-content-between">
                          <div
                            className="text-white fs-14 flex-grow-1"
                            style={{ flexBasis: "50%" }}
                          >
                            {idx + 1}. {item.CabangTujuan}
                          </div>
                          <div
                            className="text-white fs-14 text-start"
                            style={{ flexBasis: "30%" }}
                          >
                            {formatNumber(parseInt(item.total_berat))}
                          </div>
                          <div
                            className="text-white fs-14 text-end"
                            style={{ flexBasis: "20%" }}
                          >
                            {formatPercentage(item.persentase)}
                          </div>
                        </div>
                      </div>
                    )
                  )
                ) : (
                  <div className="text-white">No data</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section2;
